var exports = {
  "kL": "xfd349460--005e88--container",
  "Sl": "xfd349460--005e88--image",
  "h_": "xfd349460--005e88--description",
};

module.exports = exports;
